export default __webpack_public_path__ + "static/media/completed.45cee35b.svg";